import { useTranslation } from 'react-i18next';

import useModals from 'modals/hooks';
import { FeedbackModalTemplate } from 'modals/Templates';

import { CustomPrimaryButton } from 'components/Buttons';

import ErrorIcon from 'assets/emoji/exclamation2.svg';

const dataLocators = {
    body: 'accessCodeErrorModal',
    title: 'accessCodeErrorModalTitle',
    subTitle: 'accessCodeErrorModalSubtitle',
};

const CopyCodeErrorModal = () => {
    const { t } = useTranslation();
    const { closeModal } = useModals();

    return (
        <FeedbackModalTemplate
            title="main.step.copyCode.mobile.failure.title"
            subtitle="main.step.copyCode.mobile.failure.text"
            withCloseButton
            image={ErrorIcon}
            dataLocators={dataLocators}
        >
            <CustomPrimaryButton onClick={closeModal} dataLocator="accessCodeErrorModalBtn">
                {t('basics.close')}
            </CustomPrimaryButton>
        </FeedbackModalTemplate>
    );
};

export default CopyCodeErrorModal;
